export function sortEmployeeName (employee1, employee2) {
    var name1 = employee1.employeename.toUpperCase();
    var name2 = employee2.employeename.toUpperCase();
    if (name1 < name2) {return -1;}
    if (name1 > name2) {return 1;}
    return 0;
}

export function AccountSortByNum (account1, account2) {
  console.log("here")
  if (account1.accountnum < account2.accountnum) {return -1;}
  if (account1.accountnum > account2.accountnum) {return 1;}
  return 0;
}

export const SortMixin = {
    methods: {
      sortEmployeeName,
      AccountSortByNum
    }
};